/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { FaCog } from 'react-icons/fa';
import {
  Button,
  DropdownToggle,
  DropdownMenu,
  InputGroup,
  InputGroupAddon,
  InputGroupButtonDropdown,
} from 'reactstrap';
import PaginationControls from './PaginationControls';
import DebouncedInput from './DebouncedInput';

interface LeadControlsOptions {
  openTableOptionsModal?: () => void;
  advancedSearch?: React.ReactNode;
  inputPlaceholder?: string;
}

const LeadControls: React.SFC<LeadControlsOptions> = ({
  openTableOptionsModal,
  advancedSearch,
  inputPlaceholder = 'Search by keyword...',
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen((o) => !o);

  return (
    <div className="d-flex py-3">
      <InputGroup>
        {advancedSearch && (
          <InputGroupButtonDropdown
            addonType="prepend"
            isOpen={dropdownOpen}
            toggle={toggleDropdown}
          >
            <DropdownToggle split caret>
              Advanced Search{' '}
            </DropdownToggle>
            <DropdownMenu className="p-4">
              {advancedSearch}
              <Button
                color="secondary"
                className="float-right"
                onClick={toggleDropdown}
                style={{
                  zIndex: 0,
                }}
              >
                Close
              </Button>
            </DropdownMenu>
          </InputGroupButtonDropdown>
        )}
        <DebouncedInput
          name="searchText"
          placeholder={inputPlaceholder}
          style={{
            maxWidth: 550,
          }}
        />
        <InputGroupAddon addonType="append">
          <Button color="primary">Search</Button>
        </InputGroupAddon>
      </InputGroup>
      <div className="d-flex">
        <PaginationControls
          className="d-flex justify-content-center"
          listClassName="mb-0"
          pageRange={3}
          marginPages={0}
          directionLinks
          endLinks
        />
        {openTableOptionsModal && (
          <Button
            color="secondary"
            className="ml-2"
            onClick={openTableOptionsModal}
          >
            <FaCog />
          </Button>
        )}
      </div>
    </div>
  );
};

export default LeadControls;
